// extracted by mini-css-extract-plugin
export default {"main-div":"ErrorHandler_main-div__ccjOD","h1":"ErrorHandler_h1__MLntL"};